export default "__VITE_ASSET__eBDKrmNq__"